/* eslint-disable */
import { $http } from '@/plugins/axios';
import { AxiosResponse } from 'axios';

export const menuService = {
    list: (): Promise<AxiosResponse> => {
        return $http.get('v1/org_admin/default_meals');
    },
    updateList: (data: any): Promise<AxiosResponse> => {
        return $http.post(`v1/org_admin/default_meals/create_or_delete_many`, data);
    },
    listMenu: (page: number = 1, per_page: number = 10): Promise<AxiosResponse> => {
        return $http.get(`v1/org_admin/menus?page=${page}&page_size=${per_page}`);
    },
    listDishes: (search: string = ''): Promise<AxiosResponse> => {
        return $http.get(`v1/org_admin/dishes?query=${search}`);
    },
    createMenuForWeek: (data: any): Promise<AxiosResponse> => {
        return $http.post(`v1/org_admin/menus`, data);
    },
    updateMenuForWeek: (id: any, data: any): Promise<AxiosResponse> => {
        return $http.put(`v1/org_admin/menus/${id}`, data);
    },
    getMenuDetail: (id: string): Promise<AxiosResponse> => {
        return $http.get(`v1/org_admin/menus/${id}`);
    },
    updateMenuByDay: (id: any, data: any): Promise<AxiosResponse> => {
        return $http.post(`v1/org_admin/menus/${id}/menu_item_dishes/create_or_delete_many`, data);
    },
    duplicateMenuByDay: (id: any, data: any): Promise<AxiosResponse> => {
        return $http.post(`v1/org_admin/menus/${id}/menu_item_dishes/duplicate`, data);
    },
    deleteMenuByDay: (id: any, data: any): Promise<AxiosResponse> => {
        return $http.delete(`v1/org_admin/menus/${id}/menu_item_dishes/delete_many`, data);
    },
    sendMenuToParent: (id: any, data: any): Promise<AxiosResponse> => {
        return $http.post(`v1/org_admin/menus/${id}/send_notification`, data);
    },
    deleteMenu: (id: any): Promise<AxiosResponse> => {
        return $http.delete(`v1/org_admin/menus/${id}`);
    },
    duplicateWeekMenu: (id: any, data: any): Promise<AxiosResponse> => {
        return $http.post(`v1/org_admin/menus/${id}/duplicate`, data);
    },
    checkExistWeekMenu: (data: any): Promise<AxiosResponse> => {
        return $http.get(`v1/org_admin/menus/check_exists`, { params: data });
    },
    parentNotificationHistory: (id: any): Promise<AxiosResponse> => {
        return $http.get(`v1/org_admin/menus/${id}/parent_notification_history`);
    },
}